import { AppBar, Avatar, IconButton, Toolbar } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";


import HeaderLogo from '../../components/images/Fordlogo1.png';


const useStyles = makeStyles((theme: any) => ({
  root: {
    display: "flex",
    // marginBottom: "2%",
  },    
  toolbar: {
    paddingRight: "-19px",
    minHeight: "50px !important",
    backgroundColor: "#03025d",
    paddingLeft: '0 !important',
    display: "flex",
    justifyContent: "space-between"
  },

  rectangle: {
    width: 72,
    height: 38,
    cursor: "pointer",
    marginLeft: "10px"
  },
  time: {
    color: 'white',
    marginLeft: '30px',
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: 0
    },
  }
}));

export default function Header(props: any) {
  const classes = useStyles();
 
  return (
    <>
      <AppBar position={props.position} className={classes.root} color="inherit">
        <Toolbar className={classes.toolbar}>

         
            <> <img
              className={classes.rectangle}
              alt="Logo"
              src={HeaderLogo}
            />
              <span style={{ color: "white", fontSize: "26px",textAlign:"center" }}>Welcome To Ford</span>
            </>

          

         
        </Toolbar>
      </AppBar>
    </>
  );
}
